import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../Icon';
import { logEvent } from '../../../lib/shared/event-logger';
import { EVENT_TYPES } from '../../../lib/shared/event-types';
import speakItSrc from '../../assets/images/slide/start-speak-it.png';
import typeItSrc from '../../assets/images/slide/start-type-it.png';
import styles from './StartSlideV19.css';

const ANSWERS = [
    { id: 1, text: 'Speak it', image: speakItSrc },
    { id: 2, text: 'Type it', image: typeItSrc }
];

function StartSlideV19({ id, onContinue }) {
    const handleChange = answer => () => {
        logEvent(EVENT_TYPES.QUIZ_START_CLICKED, { label: answer.text });
        onContinue();
    };

    return (
        <div className={styles.form} key={id}>
            <h1 className={styles.heading}>Write your life story one question at a time</h1>
            <p className={styles.subheading}>How would you rather tell your story?</p>
            <ul className={styles.answers}>
                {ANSWERS.map(answer => (
                    <li key={answer.id}>
                        <button
                            type='button'
                            onClick={handleChange(answer)}
                            className={styles.answerButton}
                        >
                            <img src={answer.image} alt='' className={styles.answerImage} />
                            <span className={styles.answerLabel}>
                                <span>{answer.text}</span>
                                <Icon name='arrowRight' className={styles.answerIcon} />
                            </span>
                        </button>
                    </li>
                ))}
            </ul>
            <p className={styles.caption}>Take this quiz to personalize your subscription</p>
        </div>
    );
}

StartSlideV19.propTypes = {
    id: PropTypes.number.isRequired,
    onContinue: PropTypes.func.isRequired
};

export {
    StartSlideV19
};
